<template>
  <v-autocomplete
    v-model="selectedTractGroup"
    color="black"
    :label="$t('tractGroup')"
    :items="tractGroups"
    @change="tractGroupChosen"
    :loading="tractGroupsLoading"
    item-text="name"
    item-value="tractGroupId"
    return-object
    :clearable="!readonly"
    autocomplete="chrome-off"
    :append-icon="readonly ? '' : '$dropdown'"
    :disabled="disabled"
    :readonly="readonly"
    id="tract-group-autocomplete"
  >
    <template #item="{ item }">
      <v-row no-gutters>
        <v-col>
          {{ item.name }}
        </v-col>
        <v-col cols="auto" class="text--secondary ml-2">
          {{ item.code }}
        </v-col>
      </v-row>
    </template>
    <template #selection="{ item }">
      <v-icon color="info">mdi-arrange-send-to-back</v-icon>
      <span>{{ item.name }}</span>
      <span v-if="item.code" class="text--secondary ml-2">({{ item.code }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TractGroupAutocomplete',

  props: {
    tractGroupId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    fetchOnCreation: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    selectedTractGroup: null
  }),

  computed: {
    ...mapGetters('tract', ['allTractGroups', 'tractGroupsLoading']),

    tractGroups () {
      return this.allTractGroups || []
    }
  },

  async created () {
    if (this.fetchOnCreation && this.allTractGroups.length === 0) {
      await this.fetchTractGroups()
    }
    if (this.tractGroupId) {
      this.selectedTractGroup = this.allTractGroups.find(tg => tg.tractGroupId === this.tractGroupId)
    }
  },

  watch: {
    tractGroupId (val) {
      if (val) {
        this.selectedTractGroup = this.allTractGroups.find(tg => tg.tractGroupId === val)
      } else {
        this.selectedTractGroup = null
      }
    }
  },

  methods: {
    ...mapActions('tract', ['fetchTractGroups']),

    tractGroupChosen (tractGroup) {
      this.$emit('tract-group-chosen', tractGroup)
    }
  }
}
</script>
